module.exports = [{"id":"117","item":"e1","valor":"Lo sentimos","modulo":"errorSubnet"},{"id":"118","item":"e2","valor":"Los datos para este sitio son errorenos. Verifique la URL que se le proporcionó","modulo":"errorSubnet"},{"id":"119","item":"e3","valor":"Ruta:","modulo":"errorSubnet"}]


//////////////////
// WEBPACK FOOTER
// ./config/messages/errorSubnet.json
// module id = nG5I
// module chunks = 13